import RCSelect, { Option as RCOption } from "rc-select";
import styled, { css } from "styled-components";
import { Form } from "formik";

export const FormContainer = styled(Form)`
  width: 100%;
`;

export const InputsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  margin: 15px 0;

  p {
    color: #000000;
    font-size: 0.75rem;
    line-height: 14px;
  }
`;

type SelectProps = any;

export const Select = styled(RCSelect)<SelectProps>`
  display: flex;
  width: 100%;
  flex: 1;
  margin-top: 20px;
  cursor: pointer;

  @media (max-width: 768px) {
    margin-top: 30px;
  }

  ${(props) =>
    !props.isSelected &&
    css`
      .rc-select-selection-overflow {
        display: none !important;
      }
    `}

  ${css`
    .rc-select-selection-placeholder {
      display: flex;
      flex-direction: column;
      flex: 1;
      color: ${({ theme }) => theme.colors.gray};
      background: transparent;
      cursor: pointer;
      user-select: none;
      font-size: 1rem;
      font-weight: bold;
      opacity: 1;
    }
  `}
`;

export const Option = styled(RCOption)``;

export const Input = styled.div`
  position: relative;
  display: flex;
  background: white;
  border-radius: 5px;
  border: 1px solid ${({ theme }) => theme.colors.lightGray};
  width: 100%;
  color: ${({ theme }) => theme.colors.gray};
  padding: 8px 12px 8px 12px;
  height: 100%;

  &:focus-within {
    border: 1px solid ${({ theme }) => theme.colors.lightBlue};
  }
`;

export const TextArea = styled.textarea`
  display: flex;
  width: 100%;
  height: 70px;
  flex: 1;
  background: transparent;
  border: 0;
  color: ${({ theme }) => theme.colors.gray};
  outline: none !important;
  padding: 0;
  margin-top: 15px;

  .placeholder {
    color: ${({ theme }) => theme.colors.gray};
  }
`;

export const FieldName = styled.span`
  color: ${({ theme }) => theme.colors.mediumGray};
  position: absolute;
  padding-top: 2px;
  transition: font-size 1s;
  transform: translateY(-3px);
  font-size: 0.625rem;
`;

export const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding: 10px 0px 10px 10px;
  margin-bottom: -25px;
  @media (max-width: 1000px) {
    width: 100%;
    justify-content: center;
  }
  button {
    max-width: 300px;
    width: 100%;
  }
`;

export const InputFile = styled.input`
  display: none;
`;

export const LabelName = styled.label`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-top: 15px;
  color: ${({ theme }) => theme.colors.gray};
  background: transparent;
  cursor: pointer;
`;

export const LabelContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const FilesContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const FileItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const FileImg = styled.img`
  width: 40px;
  height: 40px;
  object-fit: cover;
`;

export const FileText = styled.div`
  display: flex;
  flex-direction: column;
  color: ${({ theme }) => theme.colors.gray};
  flex: 1;
  margin-left: 0 5px;
`;

export const FilesAbsolute = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;

  svg {
    fill: #000fff;
  }
`;

export const ButtonDelete = styled.button`
  background: transparent;
  border: none;

  svg {
    fill: #e60000;
  }
`;
